export default __webpack_public_path__ + "static/media/our-services-home-care-learning-disability-care-01.38ece7b5.jpg";